import { useCallback, useEffect, useState } from "react";

import { getDeploySetup } from "../../../services/strategyDeployApi";

/** Whether the user's Telegram is linked to the Tessera bot (null while loading), and a re-check. */
export function useTelegramLinked(): { linked: boolean | null; refresh: () => void } {
  const [linked, setLinked] = useState<boolean | null>(null);
  const refresh = useCallback(() => {
    getDeploySetup()
      .then((s) => setLinked(Boolean(s.telegram_linked)))
      .catch(() => setLinked((prev) => prev ?? false));
  }, []);
  useEffect(refresh, [refresh]);
  return { linked, refresh };
}
